define('datakit/hal/links.model',['require','exports','module','underscore','backbone','backbone.radio','../model','./link.model'],function(require, exports, module) {
  var _ = require('underscore');
  var Backbone = require('backbone');
  var Radio = require('backbone.radio');
  var Model = require('../model');
  var LinkModel = require('./link.model');

  var LinksModel = Model.extend({

    onBeforeFirstSet: function(attrs, options) {
      Model.prototype.onBeforeFirstSet.apply(this, arguments);

      this.registerSetter(_.constant(true), this.setUnkownLink)
      this.registerSerializer(this.serializeLinkEntities);
    },

    setUnkownLink: function(rel, value, options) {
      this.setWithModelClass(rel, value, LinkModel, options);
    },

    serializeLinkEntities: function(json, options) {
      _.each(json, function(entity, key) {
        json[key] = (entity && entity.toJSON) ? entity.toJSON(options) : entity;
      });
    }

  });

  Radio.channel('models').reply('DataKit.LinksModel', _.constant(LinksModel));

  module.exports = LinksModel;
});

